/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SapS4HanaGetQuoteAsSalesQuotationQueryVariables = Types.Exact<{
  docId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
  intent: Types.SapS4HanaGetQuoteAsSalesQuotationIntent;
}>;


export type SapS4HanaGetQuoteAsSalesQuotationQuery = { sapS4HanaGetQuoteAsSalesQuotation: { __typename: 'SapS4HanaGetQuoteAsSalesQuotationResult', salesQuotation: any } };


export const SapS4HanaGetQuoteAsSalesQuotationDocument = gql`
    query SapS4HanaGetQuoteAsSalesQuotation($docId: ID!, $projectId: ID!, $intent: SapS4HanaGetQuoteAsSalesQuotationIntent!) {
  sapS4HanaGetQuoteAsSalesQuotation(
    docId: $docId
    projectId: $projectId
    intent: $intent
  ) {
    salesQuotation
  }
}
    `;

/**
 * __useSapS4HanaGetQuoteAsSalesQuotationQuery__
 *
 * To run a query within a React component, call `useSapS4HanaGetQuoteAsSalesQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSapS4HanaGetQuoteAsSalesQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSapS4HanaGetQuoteAsSalesQuotationQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      projectId: // value for 'projectId'
 *      intent: // value for 'intent'
 *   },
 * });
 */
export function useSapS4HanaGetQuoteAsSalesQuotationQuery(baseOptions: Apollo.QueryHookOptions<SapS4HanaGetQuoteAsSalesQuotationQuery, SapS4HanaGetQuoteAsSalesQuotationQueryVariables> & ({ variables: SapS4HanaGetQuoteAsSalesQuotationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SapS4HanaGetQuoteAsSalesQuotationQuery, SapS4HanaGetQuoteAsSalesQuotationQueryVariables>(SapS4HanaGetQuoteAsSalesQuotationDocument, options);
      }
export function useSapS4HanaGetQuoteAsSalesQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SapS4HanaGetQuoteAsSalesQuotationQuery, SapS4HanaGetQuoteAsSalesQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SapS4HanaGetQuoteAsSalesQuotationQuery, SapS4HanaGetQuoteAsSalesQuotationQueryVariables>(SapS4HanaGetQuoteAsSalesQuotationDocument, options);
        }
export function useSapS4HanaGetQuoteAsSalesQuotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SapS4HanaGetQuoteAsSalesQuotationQuery, SapS4HanaGetQuoteAsSalesQuotationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SapS4HanaGetQuoteAsSalesQuotationQuery, SapS4HanaGetQuoteAsSalesQuotationQueryVariables>(SapS4HanaGetQuoteAsSalesQuotationDocument, options);
        }
export type SapS4HanaGetQuoteAsSalesQuotationQueryHookResult = ReturnType<typeof useSapS4HanaGetQuoteAsSalesQuotationQuery>;
export type SapS4HanaGetQuoteAsSalesQuotationLazyQueryHookResult = ReturnType<typeof useSapS4HanaGetQuoteAsSalesQuotationLazyQuery>;
export type SapS4HanaGetQuoteAsSalesQuotationSuspenseQueryHookResult = ReturnType<typeof useSapS4HanaGetQuoteAsSalesQuotationSuspenseQuery>;
export type SapS4HanaGetQuoteAsSalesQuotationQueryResult = Apollo.QueryResult<SapS4HanaGetQuoteAsSalesQuotationQuery, SapS4HanaGetQuoteAsSalesQuotationQueryVariables>;